import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookie-consent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-6 shadow-2xl z-50 border-t-4 border-yellow-500">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-bold mb-2">🍪 Cookie-Hinweis</h3>
            <p className="text-sm text-gray-300">
              Wir verwenden Cookies, um Ihnen die bestmögliche Nutzung unserer Website zu ermöglichen. 
              Durch die weitere Nutzung dieser Website stimmen Sie der Verwendung von Cookies zu. 
              Weitere Informationen finden Sie in unserer{' '}
              <a href="/datenschutz" className="text-yellow-400 hover:text-yellow-300 underline cursor-pointer">
                Datenschutzerklärung
              </a>.
            </p>
          </div>
          <div className="flex gap-3 whitespace-nowrap">
            <button
              onClick={declineCookies}
              className="px-6 py-3 bg-gray-700 hover:bg-gray-600 rounded-lg font-semibold transition-colors cursor-pointer"
            >
              Ablehnen
            </button>
            <button
              onClick={acceptCookies}
              className="px-6 py-3 bg-yellow-500 hover:bg-yellow-600 text-black rounded-lg font-semibold transition-colors cursor-pointer"
            >
              Akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
